import { VisualSuper } from "./visual-super.component.js";

class Shape extends VisualSuper {
  namespace = "visual:shape";
}

const shape = new Shape();

export { Shape, shape };
